import React, { useEffect, useState } from 'react';
import ImageUploadModal from '../../helpers/image-upload';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload } from '@fortawesome/free-solid-svg-icons';
import { ErrorMessage } from 'formik';
import { FaExclamationCircle, FaCheckCircle } from "react-icons/fa";

const InputImage = ({ attr, value, handleCroppedFoto, resetTrigger, ...props  }) => {
    const [imgValue, setImgValue] = useState('');
    const [openCropImage, setOpenCropImage] = useState(false);
    const preview = value;
    
    const handleFotoChange = (e) => {
        e.preventDefault();
        const file = e.target.files[0];

        if (!file) return;  // Ensure there is a file

        const reader = new FileReader();

        reader.onload = () => {
            setImgValue(reader.result); // Store the base64 string
            setOpenCropImage(true); // Open the cropping modal
        };

        reader.readAsDataURL(file);
    };

    const closeModal = () => {
        setOpenCropImage(false); // Close the cropping modal
    };

    const handleCropImage = (croppedImage) => {
        setOpenCropImage(false);
        handleCroppedFoto(croppedImage);
    };

    const Error = ({ name }) => (
        <ErrorMessage name={name} component="div">
            {(msg) => (
                <div className="text-red-600 font-bold text-xs mt-1 flex items-center gap-1">
                    <FaExclamationCircle className="inline-block" />
                    <span>{msg}</span>
                </div>
            )}
        </ErrorMessage>
    );

    useEffect(() => {
    if (resetTrigger) {
        handleCroppedFoto('');
        setImgValue('');
    }
    }, [resetTrigger]);

    return (
        <div {...props} className="flex-1 my-3 px-2">
            <label htmlFor={attr.name} className="block text-gray-700 text-sm font-bold mb-2 text-center">
                {attr.placeholder}
                <div className="mb-4 mt-2">
                    {preview ? (
                            <img
                            src={preview}
                            alt="Uploaded"
                            className="object-contain lg:w-64 md:w-64 sm:w-32 rounded"
                            />
                        ) : (
                            <FontAwesomeIcon icon={faUpload} size="7x" />
                        )
                    }
                </div>
                <span className='text-gray-500 text-sm'>{attr.hint}</span>
                <Error name={attr.name} />
            </label>
            <input
                style={{ display: 'none' }}
                type="file"
                id={attr.name}
                accept="image/*"
                onChange={handleFotoChange}
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            />

            <ImageUploadModal
                modalOpen={openCropImage}
                onClose={closeModal}
                fileOpen={imgValue}
                onCroped={handleCropImage}
                imgHeight={attr.height}
                imgWidth={attr.width}
                identifier="logo"
            />
        </div>
    );
};

export default InputImage;
